import { render, staticRenderFns } from "./docList.vue?vue&type=template&id=0ec85796&scoped=true"
import script from "./docList.vue?vue&type=script&lang=js"
export * from "./docList.vue?vue&type=script&lang=js"
import style0 from "./docList.vue?vue&type=style&index=0&id=0ec85796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec85796",
  null
  
)

export default component.exports